<template>
	<div id="wallet-mobile-suggester">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="title headline-l">
						{{ $t('walletScreen.mobileSuggester.title') }}
					</div>
					<!--  <div class="description headline">
            {{ $t("walletScreen.mobileSuggester.description") }}
          </div> -->
					<!-- <div class="qr-code-wrapper">
            <img class="qr-code" src="/images/screens/wallet/qr.png" />
          </div> -->
					<div class="open-application text-l">
						{{ $t('walletScreen.mobileSuggester.openApplication') }}
					</div>
					<div class="d-flex justify-content-center align-center stores-list">
						<store-button :version="'apple'" />
						<store-button :version="'google'" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WalletMobileSuggester',
	props: {},
	components: {},
	data: () => ({}),
	created() {},
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
#wallet-mobile-suggester {
	padding-bottom: $margin-m;
	text-align: center;
  background-color: #E8E8FF;

	// .qr-code-wrapper {
	//   text-align: center;
	//   margin-bottom: 45px;
	//   @media (max-width: $breakpoint-sm) {
	//     display: none;
	//   }

	//   .label {
	//     display: block;
	//     margin: 0 0 30px;
	//   }

	//   .qr-code {
	//     margin: 0 auto;
	//   }
	// }

	.title {
		color: $primary-purple;
		font-weight: bold;
		text-align: center;
		margin-bottom: 45px;
		margin-top: 80px;
		text-transform: uppercase;

		@media (max-width: $breakpoint-sm) {
			font-size: 28px;
			line-height: 35px;
      margin-bottom: 33px;
		}
	}
	.description {
		margin-bottom: 45px;
		font-weight: bold;
	}
	.open-application {
		margin-bottom: 55px;
		font-size: 18px;
		color: $text-blue;
	}
	@media (max-width: $breaking-point-to-sm) {
		//   .title {
		//     font-size: 27px;
		//   }
		//   .description {
		//     font-size: 18px;
		//   }
	}
}

.stores-list {
	button {
		@media (max-width: $breakpoint-xs) {
			display: flex;
			width: 50%;
			justify-content: center;
		}

		&:first-child {
			margin: 0 30px 0 0;

			@media (max-width: $breakpoint-xs) {
				margin: 0 20px 0 0;
			}
		}
	}
}
</style>
